export { CategoryFacet } from './CategoryFacet';
